var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.showChatChannels}},[_c('i',{staticClass:"fas fa-comments"}),_vm._v(" "),_c('span',{staticClass:"badge-unread custom-unread"},[_vm._v(_vm._s(_vm.unreadCount))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d03fc720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/chat-button.vue
// module id = null
// module chunks = 